package com.bikompanion.data.gbfs

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonNames

@OptIn(ExperimentalSerializationApi::class)
@Serializable
internal data class GbfsStationStatusDto(
    @SerialName("station_id") val stationId: String,
    // Renamed in 3.0 once a "vehicle" stopped necessarily being a bike. Both spellings are
    // accepted so one DTO covers both operators.
    @SerialName("num_vehicles_available")
    @JsonNames("num_bikes_available")
    val vehiclesAvailable: Int = 0,
    @SerialName("num_docks_available") val docksAvailable: Int = 0,
    @SerialName("is_installed") val isInstalled: Boolean = true,
    @SerialName("is_renting") val isRenting: Boolean = true,
    @SerialName("is_returning") val isReturning: Boolean = true,
    @SerialName("vehicle_types_available")
    val vehicleTypesAvailable: List<GbfsVehicleTypeCountDto> = emptyList(),
)
